

export function dynamicSort(property, reverseOrder = false) {
	let sortOrder = reverseOrder ? -1 : 1;
	return function (a,b) {
		a[property] = a[property] === null ? '' : a[property];
		b[property] = b[property] === null ? '' : b[property];
		let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
		if (typeof a[property] === 'string' && typeof b[property] === 'string') {
			result = (a[property].toLowerCase() < b[property].toLowerCase()) ? -1 : (a[property].toLowerCase() > b[property].toLowerCase()) ? 1 : 0;
		}
	  return result * sortOrder;
	}
}